export const en = {
  en: {
    translation: {
      confirm_app_exit: 'Are you sure you want to leave Baby Shark World for Kids?',
      button_exit: 'Leave',
      button_cancel: 'Cancel',
      os_update: 'Please update to the latest TV OS version and try again.',
      button_ok: 'OK',
      t_complete_app_update: 'Baby Shark World for Kids has been updated.',
      error_title: 'An error has occurred',
      error_unknown: 'Please restart the app.',
      error_network_title: 'Unstable internet connection.',
      error_network: 'Check your network connection and try again.',
      button_retry: 'Retry',
      confirm_continue_watching: 'Would you like to continue watching?',
      button_continue_watching: 'Continue Watching',
      button_from_beginning: 'Watch From Start',
      t_event_coming_soon: 'Coming Soon',
      data_fail: 'An error has occurred. \nPlease restart the app.',
      page_sign_in_header: 'Sign in with QR code',
      page_sign_in: 'You need to sign in to use the service. \nScan the QR code to sign in.',
      page_sign_in_code: 'Verification Code',
      page_sign_in_time: 'Time Remaining',
      oauth_confirm_code: "Please check \nif it matches the TV's verification code",
      oauth_web_info: 'Web browser',
      oauth_device_info: 'Device access information',
      oauth_accept_sign_in: 'Accept sign in',
      oauth_sign_in_success: 'Device sign in successful.',
      oauth_sign_in_cancel: 'Device sign in cancelled.',
      oauth_sign_in_fail: 'Error. \nRetry sign in with QR code.',
      oauth_sign_in_expired: "Login session expired. \nRescan the TV's QR code to log in.",
      menu_my: 'MY',
      menu_home: 'Home',
      menu_story: 'Story',
      menu_song: 'Song',
      menu_cinema: 'Cinema',
      menu_cinema_and_tv: 'Cinema & TV Series',
      menu_ip: 'IP',
      menu_topics: 'Topics',
      menu_home_history: 'Recently Watched',
      title_ai_videos: 'Videos Curated by AI',
      menu_home_new_content: "What's New",
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: 'No active subscription',
      mypage_menu_status_susbcribed: '<span class="text-secondary">Subscribed</span> to Pinkfong Plus',
      mypage_menu_benefits_unsusbcribed: 'Subscription Benefits',
      mypage_menu_benefits_susbcribed: 'Current Benefits',
      mypage_menu_benefits_01: 'Over 20,000 original series available',
      mypage_menu_benefits_02: 'Regularly updated exclusive content',
      mypage_menu_benefits_03: 'With a single subscription, \naccess on both TV and mobile',
      mypage_menu_benefits_04: 'Over 30+ engaging learning apps with unlimited access',
      mypage_scan_to_subscribe: 'Scan QR code to subscribe',
      mypage_video_title: 'What’s Pinkfong Plus?',
      mypage_menu_terms: 'Terms and Conditions',
      mypage_menu_event: 'Promotion',
      mypage_menu_support: 'Support',
      button_sign_out: 'Sign Out',
      mypage_menu_event_coming_soon: 'Coming Soon',
      mypage_menu_even_open: 'Open',
      terms_required_privacy: 'Privacy Policy',
      terms_required_pinkfong: 'Terms of Service',
      terms_required_interactive: 'Terms of Pinkfong Interactive Apps',
      mypage_menu_device_info: 'Device Information',
      page_device_info: 'Contact us with the following information for faster issue resolution.',
      page_device_info_model: 'Device Model',
      page_device_info_os: 'OS Platform',
      page_device_info_version: 'App Version',
      page_support: 'For service assistance, please contact us.\ncs@pinkfong.com',
      caution_sign_out: 'Sign out will restrict service access.',
      topic_category_all: 'All',
      player_language_button: 'Language',
    },
  },
};
